import { render, staticRenderFns } from "./AdminCustomerModal.vue?vue&type=template&id=ac8691a6&scoped=true&"
import script from "./AdminCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./AdminCustomerModal.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCustomerModal.vue?vue&type=style&index=0&id=ac8691a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8691a6",
  null
  
)

export default component.exports